import { render, staticRenderFns } from "./selectBankPage.vue?vue&type=template&id=6c87bffc&scoped=true&lang=pug"
import script from "./selectBankPage.vue?vue&type=script&lang=js"
export * from "./selectBankPage.vue?vue&type=script&lang=js"
import style0 from "./selectBankPage.vue?vue&type=style&index=0&id=6c87bffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87bffc",
  null
  
)

export default component.exports